import React, { useState, useRef } from "react";
import axios from "axios";
import DisplayUploads from "./DisplayUploads";
import { API_BASE_URL } from "./Constants";
const FileUpload = (props) => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const enrollId = props.id;  

  const fileInputRef = useRef(null);  // Add this line

  const handleSubmit = async (e) => {
 
    e.preventDefault();
    if (!title || !file) {
      setMessage("Both fields are required.");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("file", file);
    formData.append("enrollment_id", enrollId);
    formData.append("type", "student-resource");

    try {
      await axios.post(`${API_BASE_URL}/api/upload-file`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage("Upload successful!");
      setTitle("");
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";   // Clear file input value here
      }
    } catch (err) {
      setMessage("Upload failed: " + (err.response?.data?.message || err.message));
    }
    setLoading(false);
  };

  return (
    <>
    <form className="space-y-4 bg-base-200 p-8 rounded-xl shadow-md max-w-md mx-auto" onSubmit={handleSubmit}>
      {/* Title Input */}
      <label className="form-control w-full">
        <div className="label">
          <span className="label-text">Title</span>
        </div>
        <input
          type="text"
          className="input input-bordered w-full"
          placeholder="Enter title"
        value={title}
        onChange={e => {
          setTitle(e.target.value);
          setMessage("");
        }}
        disabled={loading}
        />
      </label>
      {/* File Input */}
      <label className="form-control w-full">
        <div className="label">
          <span className="label-text">File</span>
        </div>
        <input
          ref={fileInputRef}                      // Attach ref here
          type="file"
          className="file-input file-input-bordered w-full"
          onChange={e => setFile(e.target.files[0])}
          disabled={loading}
        />
      </label>
      {/* Submit Button */}
      <button className="btn btn-primary w-full" type="submit" disabled={loading}>
        {loading ? (
          <span>
            <span className="loading loading-spinner loading-sm mr-2"></span> Loading...
          </span>
        ) : (
          "Upload"
        )}
      </button>
      {message && <div className="text-center text-info">{message}</div>}
    </form>
<hr/>
    {!loading && <DisplayUploads id={enrollId} />}
  </>
  );
};

export default FileUpload;
